import styled from "styled-components";

export const LayoutMainBlock = styled.div`
  width: 100%;
`;

export const ContentBlock = styled.div`
  margin-left: 100px;

  /* Keep in lockstep with SidebarBlock's hide breakpoint (SideBar/styled.js). */
  @media (max-width: 768px) {
    margin-left: 0;
  }
`;
